import { createUseStyles } from 'react-jss';
import { cssColorPrimary } from '../../constants/globalcss';

export const useStyles = createUseStyles({
  caption: {
    color: '#888',
    display: 'block',
    marginBottom: 8,
    marginTop: 8,
    textAlign: 'center',
  },

  // Legacy styles (kept for backward compatibility)
  completeField: {
    color: '#888',
    display: 'block',
    marginBottom: 8,
  },

  // Main container styles
  container: {
    margin: '0 auto',
    width: '100%',
  },

  // Main content layout
  contentContainer: {
    '@media (max-width: 599px)': {
      alignItems: 'stretch',
      flexDirection: 'column',
    },
    alignItems: 'stretch',
    display: 'flex',
    gap: 16,
  },

  // Upload area styles
  dragBox: {
    '&.active': {
      background: '#f0f7ff',
      border: '2px solid #1976d2',
    },
    '&.disabled': {
      cursor: 'not-allowed',
      opacity: 0.6,
    },
    '&:focus': {
      outline: '2px solid #1976d2',
      outlineOffset: 2,
    },
    alignItems: 'center',
    background: '#fafafa',
    border: '2px dashed #ccc',
    borderRadius: 8,
    cursor: 'pointer',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    margin: 16,
    minHeight: 120,
    padding: 24,
    textAlign: 'center',
    transition: 'border 0.2s, background 0.2s',
  },

  errorAlert: {
    marginBottom: 8,
  },

  // Error messages container
  errorContainer: {
    marginTop: 16,
  },

  fileCount: {
    color: '#888',
    marginBottom: 8,
  },

  fileIcon: {
    minWidth: 36,
  },

  // File list
  fileList: {
    maxHeight: 200,
    overflow: 'auto',
  },

  // File list container
  fileListContainer: {
    '@media (max-width: 599px)': {
      minHeight: 'auto',
    },
    '@media (min-width: 600px)': {
      minHeight: 120,
    },
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  // File list header
  fileListHeader: {
    alignItems: 'center',
    display: 'flex',
    gap: 16,
    justifyContent: 'center',
    marginBottom: 8,
  },

  // File list item
  fileListItem: {
    paddingBottom: 4,
    paddingTop: 4,
  },

  fileName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  // Help text
  helpText: {
    color: '#666',
    display: 'block',
    marginTop: 8,
  },

  // Paper container
  paper: {
    marginBlock: 16,
    paddingBlock: 8,
    paddingInline: 16,
    width: '100%',
  },

  // Progress bar container
  progressContainer: {
    marginBottom: 8,
  },

  progressText: {
    textAlign: 'center',
  },

  // Required indicator
  requiredIndicator: {
    marginLeft: 4,
  },

  supportedTypesText: {
    color: '#666',
    marginTop: 4,
    textAlign: 'center',
  },

  uploadContainer: {
    display: 'flex',
    width: 500,
  },

  // Upload icon styles
  uploadIcon: {
    '&.active': {
      color: '#1976d2',
    },
    '&.inactive': {
      color: '#666',
    },
    color: cssColorPrimary,
    fontSize: 48,
    marginBottom: 8,
  },
  // Upload text styles
  uploadText: {
    marginBottom: 8,
    textAlign: 'center',
  },
});
